module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesLuxury@2x.09faf13.jpg";